module.exports = __webpack_public_path__ + "static/media/SILVER SMALL BANNER.3926bcc0.png";